<h1 mat-dialog-title>Permissões do token</h1>
<div mat-dialog-content>
  <p>Selecione somente as regras que este token poderá utilizar.</p>
  <mat-checkbox *ngFor="let regra of data.regras" [checked]="selecionadas.includes(regra.idRegra)" (change)="alterar(regra.idRegra, $event.checked)">{{ regra.noRegra }}</mat-checkbox>
</div>
<div mat-dialog-actions align="end"><button mat-button mat-dialog-close>Cancelar</button><button mat-raised-button color="primary" (click)="salvar()">Salvar</button></div>
